<button #notificationsButton mat-raised-button (click)="showNotifications()" class="notifications" matTooltip="Click to view notifications">
  <div *ngIf="newNotificationCount > 0" class="dot"></div>
  <mat-icon class="notifications material-symbols-outlined">notifications</mat-icon>
</button>
